import { collection, deleteDoc, doc, getDocs, setDoc } from "firebase/firestore";

import {
  ensureFirebaseAuth,
  firebaseDb,
  isFirebaseConfigured,
  tryEnsureFirebaseAuth,
} from "data/firebase";

function requireDb() {
  if (!isFirebaseConfigured || !firebaseDb) {
    throw new Error("Firebase yapılandırılmamış.");
  }
  return firebaseDb;
}

function makeId(prefix) {
  return `${prefix}_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`;
}

export async function listAppNotificationsFromFirestore() {
  const db = requireDb();
  await tryEnsureFirebaseAuth();
  const snap = await getDocs(collection(db, "appNotifications"));
  return snap.docs
    .map((d) => ({ id: d.id, ...(d.data() || {}) }))
    .sort((a, b) => String(b.createdAt || "").localeCompare(String(a.createdAt || "")));
}

export async function listNotificationRecipientsFromFirestore() {
  const db = requireDb();
  await tryEnsureFirebaseAuth();
  const snap = await getDocs(collection(db, "notificationRecipients"));
  return snap.docs.map((d) => ({ id: d.id, ...(d.data() || {}) }));
}

export async function sendAppNotificationToFirestore({ title, body, action = "none", createdByName }) {
  const db = requireDb();
  await ensureFirebaseAuth();
  const recipients = await listNotificationRecipientsFromFirestore();
  const id = makeId("ntf");
  const notification = {
    id,
    title: String(title || "").trim(),
    body: String(body || "").trim(),
    action: action || "none",
    audience: "members",
    recipientCount: recipients.length,
    createdAt: new Date().toISOString(),
    createdByName: createdByName || "admin",
    kind: "appNotification",
  };
  if (!notification.title || !notification.body) {
    throw new Error("Başlık ve mesaj zorunludur.");
  }
  await setDoc(doc(db, "appNotifications", id), notification, { merge: true });
  return notification;
}

export async function deleteAppNotificationFromFirestore(id) {
  const db = requireDb();
  await ensureFirebaseAuth();
  await deleteDoc(doc(db, "appNotifications", id));
}
